"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnderConstruction = void 0;
var react_1 = __importDefault(require("react"));
var lib_1 = require("./lib");
var outer = lib_1.scopedStyles("UnderConstruction", {
    cursor: "not-allowed",
    "&:active": {
        outline: "2px solid red !important",
    },
});
var inner = lib_1.scopedStyles("UnderConstruction", {
    pointerEvents: "none",
});
function UnderConstruction(props) {
    var children = props.children;
    return (react_1.default.createElement("div", { className: outer },
        react_1.default.createElement("div", { className: inner }, children)));
}
exports.UnderConstruction = UnderConstruction;
//# sourceMappingURL=UnderConstruction.js.map